const accessTokenName = "admin-accessToken";

export const getAccessToken = () => {
    return localStorage.getItem(accessTokenName);
};
